import { render, staticRenderFns } from "./m-orm-table-dialog.vue?vue&type=template&id=44c904c0&scoped=true&lang=pug&"
import script from "./m-orm-table-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-table-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-table-dialog.vue?vue&type=style&index=0&id=44c904c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c904c0",
  null
  
)

export default component.exports